import { Modal, ModalBody, ModalFooter, ModalHeader } from "flowbite-react";
import React from "react";

function TestScriptInfoPopup({
  scriptCheckInfoPopup,
  setscriptCheckInfoPopup,
  scriptCheckFn,
}) {
  return (
    <div>
      <Modal
        size="xl"
        className="domain-popup"
        show={scriptCheckInfoPopup}
        onClose={() => {
          setscriptCheckInfoPopup(false);
        }}
      >
        <ModalHeader className="bg-[#FAFBFC]">
          <svg className="icon text-[20px] mt-[3px] me-2 ">
            <use href="#icon_info_new"></use>
          </svg>
          About to test your script
        </ModalHeader>
        <ModalBody>
          <div className="bg-[#FAFBFC] rounded-[15px] p-4 font-semibold text-[#2A2A2A]">
            <p className="pb-2">
              The verification process will open your website in a pop-up window
              to begin the process.
            </p>
            <p className="pb-2">
              Please do not close the pop-up window until the test is finished.
            </p>
            <p>
              {" "}
              We'll update you with the results as soon as the verification
              process is finished, this normally only takes a few seconds.
            </p>
          </div>
        </ModalBody>
        <ModalFooter className="border-0">
          <div className="flex items-center justify-end w-full">
            <button
              type="default"
              className="py-2 max-w-[180px] w-full me-6 rounded-[20px] font-semibold text-[18px] ring-[1px] ring-[#2A2A2A] ring-inset hover:ring-[none] bg-gradient-to-r hover:from-[#5E78F4] hover:to-[#F14CE2] hover:text-white hover:transition hover:delay-75"
              onClick={() => {
                setscriptCheckInfoPopup(false);
              }}
            >
              Cancel
            </button>

            <button
              type="default"
              className="py-2 max-w-[180px] w-full rounded-[20px] font-semibold text-[18px] ring-[1px] ring-[#2A2A2A] ring-inset hover:ring-[none] bg-gradient-to-r hover:from-[#5E78F4] hover:to-[#F14CE2] hover:text-white hover:transition hover:delay-75 flex items-center justify-center"
              onClick={() => {
                scriptCheckFn();
                setscriptCheckInfoPopup(false);
              }}
            >
              Yes, Continue
            </button>
          </div>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default TestScriptInfoPopup;
